export const CODE_SKILLS = [
  {
    label: "ReactJs / React Native / Typescript",
    icon: "fab fa-react",
  },
  {
    label: "NextJs / Hooks / Redux",
    icon: "fas fa-code",
  },
  {
    label: "Jest / Enzyme / React Testing Library",
    icon: "fas fa-shield-alt",
  },
  {
    label: "Ant Design & Styled Components",
    icon: "fas fa-magic",
  },
  {
    label: "Storybook / CMS",
    icon: "fas fa-server",
  },
  {
    label: "HTML / CSS / Responsive Design",
    icon: "fab fa-css3",
  },
  {
    label: "Git / GitLab",
    icon: "fab fa-git",
  },
  {
    label: "Agile Methodology / Kanban",
    icon: "fas fa-code-branch",
  },
]

export const INTERESTS = [
  {
    label: "Photography",
    icon: "fas fa-image",
  },
  {
    label: "MMA & Weightlifting",
    icon: "fas fa-dumbbell",
  },
  {
    label: "Reading (mostly sci-fi and fantasy)",
    icon: "fas fa-book",
  },
  {
    label: "Video games big enthusiast",
    icon: "fas fa-gamepad",
  },
  {
    label: "Travelling",
    icon: "fas fa-rocket",
  },
]
